import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { DashboardGrid } from './DashboardGrid';
import { LoadingSpinner } from '../Common/LoadingSpinner';
import { useAuthState } from '../Layout/AuthGate';
import { showToast } from '../../hooks/useToast';

export function OrgDashboard() {
  const auth = useAuthState();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.getDashboards()
      .then(setData)
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  if (loading) return <LoadingSpinner label="Loading dashboard…" />;
  if (!data?.org) return <div className="text-sm text-text-muted">No org dashboard configured.</div>;

  const widgets = data.org.widgets ?? [];

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="text-xs text-text-muted">{widgets.length} widget{widgets.length === 1 ? '' : 's'}</div>
        {auth.role === 'admin' && (
          <div className="text-xs text-text-muted">Manage widgets from the Saved Reports page.</div>
        )}
      </div>
      <DashboardGrid
        widgets={widgets}
        onRemove={auth.role === 'admin' ? async (widgetId) => {
          try {
            await api.removeWidget(data.org.id, widgetId);
            showToast('success', 'Widget removed');
            load();
          } catch (err: any) {
            showToast('error', err.message ?? 'Remove failed');
          }
        } : undefined}
      />
    </div>
  );
}
